import type { CountryCode } from "@autorepair/contracts";

export { SUPPORTED_COUNTRY_CODES } from "@autorepair/contracts";
export type { CountryCode } from "@autorepair/contracts";

export const COUNTRY_NAMES: Record<CountryCode, string> = {
  US: "United States",
  CA: "Canada",
};

/** Two-letter US state/territory codes — a plain, general-purpose address
 * constant. NOT the same list as plateDecode.ts's own US_STATE_CODES
 * (that one is scoped to the dormant plate-decoder feature's own doc
 * comments) — kept separate here to avoid a confusing cross-feature
 * import, even though the values happen to be identical today. */
export const US_STATE_CODES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FL", "GA", "HI", "ID", "IL", "IN", "IA",
  "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM",
  "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA",
  "WV", "WI", "WY",
] as const;

/** Two-letter Canadian province/territory codes. */
export const CA_PROVINCE_CODES = [
  "AB", "BC", "MB", "NB", "NL", "NS", "NT", "NU", "ON", "PE", "QC", "SK", "YT",
] as const;

export function regionCodesFor(country: CountryCode): readonly string[] {
  return country === "CA" ? CA_PROVINCE_CODES : US_STATE_CODES;
}

export function postalCodeLabel(country: CountryCode): string {
  return country === "CA" ? "Postal Code" : "ZIP Code";
}

export function regionFieldLabel(country: CountryCode): string {
  return country === "CA" ? "Province" : "State";
}

/** Best-effort guess at the shop's country from the browser's own locale
 * (e.g. "en-CA" -> "CA") — only ever used to pre-fill the Country field
 * when provisioning a brand-new tenant, never to override a value the
 * shop already set. Falls back to "US" for anything else, including a
 * locale with no region subtag at all. */
export function guessCountryFromLocale(): CountryCode {
  const locale = typeof navigator !== "undefined" ? navigator.language : "";
  return locale.toUpperCase().endsWith("-CA") ? "CA" : "US";
}
